<div class="scrollbar app">
  <div class="border pad15 mb15">
    <div class="chat-header position-relative bgwhatsappgreen py-2 px-2 clrwhite fs13px d-flex align-items-center">
      <div class="col-6">
        <img alt="User" [src]="whatsAppChats.chatHeader.customerImage" height="30" class="mr-2">
        <span>{{ whatsAppChats.chatHeader.customerName }} ({{ whatsAppChats.chatHeader.customerNo }})</span>
      </div>
      <div class="col-6 text-right">
        <a class="btn text-white" (click)="refreshChat()" ngbTooltip="{{'lblRefresh' | translate}}">
          <i class="fa fa-sync fa-lg mr-2"></i></a>
      </div>
    </div>
    <div class="chat-body bgwhatsapp py-2 px-2 d-flex flex-column" #scrollChat [scrollTop]="scrollChat.scrollHeight"
      style="scroll-behavior: smooth;">
      <div *ngFor="let chat of whatsAppChats.chatDetail; let i=index;">
        <div class="position-relative chat_with_date">
          <div class="h-46px"></div>
          <div class="chatdate">
            <div *ngIf="chat.seqNo === 1" class="chatdate-inner rounded-pill py-1 px-2">
              {{ chat.createdDate | date:"d MMMM y"}}
            </div>
          </div>
          <div *ngIf="chat.whatsAppStatus === 'received'"
            class="d-flex justify-content-end align-items-start main-chat-container customer-reply-chat">
            <div class="ml-3 chattxt-contrainer">
              <div class="chattxt d-flex justify-content-end position-relative">
                <div class="chattxtinner py-2 px-3">
                  <div>
                    <div>
                      {{ chat.whatsAppMessage }}
                    </div>
                    <div class="cursor-pointer d-none" data-toggle="modal" data-target="#whatsAppLogFileView">
                      <i class="fa fa-paperclip mr-2"></i>
                      <span class="bold text-underline">whatsAppFileName</span>
                    </div>
                  </div>
                  <div class="chat-status d-flex align-items-center justify-content-between medium mt-2">
                    <span>{{ chat.createdDate | date:"hh:mm a"}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="img-container bgwhite">
              <img alt="customer logo" [src]="whatsAppChats.chatHeader.customerImage">
            </div>
          </div>

          <div *ngIf="chat.whatsAppStatus !== 'received'"
            class="d-flex justify-content-end align-items-start main-chat-container">
            <div class="mr-3 chattxt-contrainer">
              <div class="chattxt d-flex justify-content-end position-relative">
                <div class="chattxtinner py-2 px-3">
                  <div>
                    <div>
                      {{ chat.whatsAppMessage }}
                    </div>
                    <div class="cursor-pointer d-none" data-toggle="modal" data-target="#whatsAppLogFileView">
                      <div class="min-h-150px">
                        <img class="max-h-150px" alt="chat.whatsAppStatus">
                      </div>
                      <div class="d-flex">
                        <div class="chatmedia bgwhite p-2 w-100">
                          <i class="fa fa-paperclip mr-2"></i>
                          <span class="bold text-underline">whatsAppFileName</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chat-status d-flex align-items-center justify-content-between medium mt-2 d-none">
                    <span class="mr-4 d-flex align-items-center">
                      <img class="mr-1" src="/assets/img/icons/queued_icon.png" height="14" alt="chat.whatsAppStatus"
                        *ngIf="chat.whatsAppStatus=='queued'">

                      <img class="mr-1" src="/assets/img/icons/sending_icon.png" height="14" alt="chat.whatsAppStatus"
                        *ngIf="chat.whatsAppStatus=='sending'">

                      <img class="mr-1" src="/assets/img/icons/sent_icon.png" height="14" alt="chat.whatsAppStatus"
                        *ngIf="chat.whatsAppStatus=='sent'">

                      <img class="mr-1" src="/assets/img/icons/failed_icon.png" height="14" alt="chat.whatsAppStatus"
                        *ngIf="chat.whatsAppStatus=='failed'">

                      <img class="mr-1" src="/assets/img/icons/delivered_icon.png" height="14" alt="chat.whatsAppStatus"
                        *ngIf="chat.whatsAppStatus=='delivered'">

                      <img class="mr-1" src="/assets/img/icons/undelivered_icon.png" height="14"
                        alt="chat.whatsAppStatus" *ngIf="chat.whatsAppStatus=='undelivered'">

                      <img class="mr-1" src="/assets/img/icons/read_icon.png" height="14" alt="chat.whatsAppStatus"
                        *ngIf="chat.whatsAppStatus=='read'">

                      <img class="mr-1" src="/assets/img/icons/pending_icon.png" height="14" alt="chat.whatsAppStatus"
                        *ngIf="chat.whatsAppStatus=='pending'">

                      <span class="text-capitalize">
                        {{ chat.whatsAppStatus }}
                      </span>
                    </span>
                    <span>{{ chat.createdDate | date:"hh:mm a"}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="img-container bgwhite">
              <img alt="Sytner logo" [src]="whatsAppChats.chatHeader.adminImage">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chat-footer bgwhatsapp p-2 pb-3 px-2">
      <div class="d-flex bgwhite rounded-3 overflow-hiden position-relative border-grey1">
        <textarea class="w-100 pl-3 pt-25 rounded-3" [(ngModel)]="message" #whatsappChat maxlength='1600'
          name="whatsAppMessage" id="whatsAppMessage" placeholder="Enter message here.." (focus)="hidePlaceholder=true"
          (blur)="hidePlaceholder=false" [class.hide-placeholder]="hidePlaceholder"></textarea>
        <i class="fa fa-paperclip"></i>
      </div>
      <p class="static-msgtxt px-3 py-25 border-grey1 mb-0 d-none">
        {{'UpdatePageMessage' | translate}}
      </p>
    </div>
    <div class="d-flex justify-content-end p-2">
      <button class="btn btn-md btn-secondary" type="button" (click)="clearSendMessage()" [disabled]="message.trim()===''">
        {{ 'Clear' | translate }}
      </button>
      <button class="btn btn-md btn-primary ml-2" type="button" (click)="sendMessage()" [disabled]="message.trim()===''">
        {{ 'Send' | translate }}
      </button>
    </div>
  </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
  <div class="d-flex flex-sm-row flex-column justify-content-end">
    <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate>
      <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
  </div>
</div>